import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=18165b12&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=18165b12&prod&lang=sass&scoped=true&"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=18165b12&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18165b12",
  null
  
)

export default component.exports